interface Props {
  csrfToken: string;
}

export default function GoogleButton({ csrfToken }: Props) {
  return (
    <form action="/users/auth/google_oauth2" method="post" data-turbo="false">
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <button
        type="submit"
        className="w-full flex items-center justify-center gap-2 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 rounded-lg"
      >
        <span aria-hidden>G</span>
        Войти через Google
      </button>
    </form>
  );
}
